const PAUSE_MESSAGE = JSON.stringify({ event: "command", func: "pauseVideo", args: "" });

let visibilityObserver = null;

function getObserver() {
  if (visibilityObserver) return visibilityObserver;

  visibilityObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) continue;
        const frame = entry.target.querySelector("iframe");
        frame?.contentWindow?.postMessage(PAUSE_MESSAGE, "*");
      }
    },
    { threshold: 0.25 }
  );

  return visibilityObserver;
}

function play(button) {
  const wrapper = button.closest("[data-yt-id]");
  const videoId = wrapper?.dataset.ytId;
  if (!wrapper || !videoId) return;

  const params = new URLSearchParams({
    autoplay: "1",
    rel: "0",
    playsinline: "1",
    modestbranding: "1",
    enablejsapi: "1",
    origin: window.location.origin,
  });

  const frame = document.createElement("iframe");
  frame.src = `https://www.youtube-nocookie.com/embed/${videoId}?${params}`;
  frame.title = wrapper.dataset.ytTitle || "YouTube";
  frame.className = "product-media-yt__frame";
  frame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
  frame.allowFullscreen = true;

  wrapper.replaceChildren(frame);
  wrapper.classList.add("is-playing");
  getObserver().observe(wrapper);
}

document.addEventListener("click", (event) => {
  const button = event.target instanceof Element ? event.target.closest("[data-yt-play]") : null;
  if (!button) return;

  event.preventDefault();
  play(button);
});

/**
 * The "inside" thumbnail strip floats above the gallery and would cover the
 * YouTube player controls. Reserve that height at the bottom of video slides so
 * the strip sits below the player.
 */
function syncThumbnailReserve(gallery) {
  const thumbnails = gallery.querySelector(".media-gallery__carousel-thumbnails--inside");
  const swiper = gallery.querySelector("carousel-slider")?.swiperInstance;

  // Only the carousel stacks the strip on top of the media. In the desktop grid
  // layout the swiper is destroyed and the strip sits below the whole column.
  const overlaps =
    thumbnails instanceof HTMLElement &&
    thumbnails.offsetHeight > 0 &&
    thumbnails.offsetParent !== null &&
    swiper &&
    !swiper.destroyed;

  if (!overlaps) {
    gallery.style.removeProperty("--yt-thumbs-reserve");
    return;
  }

  const offset = parseFloat(getComputedStyle(thumbnails).bottom) || 0;
  gallery.style.setProperty("--yt-thumbs-reserve", `${Math.round(thumbnails.offsetHeight + offset + 8)}px`);
}

function syncAllThumbnailReserves() {
  for (const gallery of document.querySelectorAll("media-gallery")) {
    if (gallery.querySelector(".product-media-yt")) syncThumbnailReserve(gallery);
  }
}

let resizeTimer = null;

window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  // Twice: the swiper is created/destroyed on the 768px breakpoint after resize.
  resizeTimer = setTimeout(() => {
    syncAllThumbnailReserves();
    setTimeout(syncAllThumbnailReserves, 400);
  }, 150);
});

document.addEventListener("variant:update", () => requestAnimationFrame(syncAllThumbnailReserves));

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", syncAllThumbnailReserves, { once: true });
} else {
  syncAllThumbnailReserves();
}

window.addEventListener("load", syncAllThumbnailReserves);
